"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasSmoothScroll = function () {
    return "scrollBehavior" in document.documentElement.style;
};
exports.default = hasSmoothScroll;
